import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";

import { useGetFutureControlResultsInfinite } from "api/generated/control-results/control-results";
import {
    FutureControlResultPaginatedListDto,
    GetFutureControlResultsParams,
} from "api/generated/model";

import { deduplicateArrayByKeyCallback } from "../utils/filterUtils";

interface DashboardFutureControlResultsParams {
    controlProgramIds?: number[];
    dueDateStart?: string;
    dueDateEnd?: string;
    limit?: number;
    enabled?: boolean;
}

export function useDashboardFutureControlResultsQuery(
    params: DashboardFutureControlResultsParams
) {
    const filterParams: GetFutureControlResultsParams = {
        ...(params.controlProgramIds && {
            control_program_ids: params.controlProgramIds,
        }),
        ...(params.dueDateStart && {
            due_date_start: params.dueDateStart,
        }),
        ...(params.dueDateEnd && {
            due_date_end: params.dueDateEnd,
        }),
        ...(params.limit && {
            limit: params.limit,
        }),
    };

    return useGetFutureControlResultsInfinite(filterParams, {
        query: {
            enabled: params.enabled ?? true,
            initialPageParam: "",
            getNextPageParam: (lastPage) => lastPage.data.pagination.next,
            select: (data): FutureControlResultPaginatedListDto => {
                return {
                    content: data.pages.flatMap((page) => page.data.content),
                    linkedResources: {
                        controlPrograms: data.pages
                            .flatMap(
                                (page) =>
                                    page.data.linkedResources.controlPrograms
                            )
                            .filter(
                                deduplicateArrayByKeyCallback(
                                    (cp) => cp.resource.id
                                )
                            ),
                        controls: data.pages.flatMap(
                            (page) => page.data.linkedResources.controls
                        ),
                        users: data.pages.flatMap(
                            (page) => page.data.linkedResources.users
                        ),
                        controlResultUserPools: data.pages.flatMap(
                            (page) =>
                                page.data.linkedResources.controlResultUserPools
                        ),
                        entities: data.pages
                            .flatMap(
                                (page) => page.data.linkedResources.entities
                            )
                            .filter(deduplicateArrayByKeyCallback((e) => e.id)),
                        classification:
                            data.pages[0].data.linkedResources.classification,
                    },
                    pagination: {
                        prev: null,
                        next: null,
                    },
                };
            },
            staleTime: STALE_TIME_RESOURCES,
        },
    });
}
